import * as React from "react";
const SvgFiRrDamage = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-damage_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5M5 22a2.97 2.97 0 0 1-1.888-.688l8.335-4.163a1 1 0 1 0-.893-1.789l-2.553 1.275v-2.636a1 1 0 0 0-2 0v3.635l-3.939 1.968A3 3 0 0 1 2.001 19V5c0-1.654 1.346-3 3-3h2.023l2.261 4.377A2.99 2.99 0 0 0 11.951 8h1.471l1.712 2.996a1 1 0 1 0 1.736-.992L15.725 8h2.277a1 1 0 0 0 0-2h-6.051a1 1 0 0 1-.888-.541L9.277 2h9.725c1.654 0 3 1.346 3 3v14c0 .22-.027.432-.072.639l-5.288-4.407a1 1 0 0 0-1.28 1.536l5.49 4.575a2.97 2.97 0 0 1-1.85.657z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-damage_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDamage;
